import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
	FrontendOrder,
	FrontendProductOrder,
} from "node-library/dist/portal";
import AdminOrderCell from "./AdminOrderCell";

interface Props {
	orders: Array<FrontendProductOrder>;
	user: FrontendUserInfo | undefined;

	// sortBy: OrderTableSortColumn;
	// setSortBy: React.Dispatch<React.SetStateAction<OrderTableSortColumn>>;
	// sortOrder: SortOrder;
	// setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
	deleteOrder: (order: FrontendProductOrder) => void;

	goToEditOrderPage: (order: FrontendProductOrder) => void;
	goToViewOrderDetails: (order: FrontendProductOrder) => void;
	viewOrderCOC: (order: FrontendProductOrder) => void;

	goToOrderReportPage: (order: FrontendProductOrder) => void;

	setDiscardOrderConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function AdminViewOrdersTableGridView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		orders,
		// sortBy,
		// setSortBy,
		// sortOrder,
		// setSortOrder,
		deleteOrder,
		goToViewOrderDetails,
		goToEditOrderPage,
		viewOrderCOC,
		goToOrderReportPage,
		setDiscardOrderConfirmOpen,
		setProceedAction,
	} = props;

	const sampleCells: Array<React.ReactNode> = orders
		? orders.map((order: FrontendProductOrder, index: number) => {
				return (
					<AdminOrderCell
						key={order.orderId}
						order={order}
						user={props.user}
						viewOrderCOC={() => {
							viewOrderCOC(order);
						}}
						goToViewOrderDetails={() => goToViewOrderDetails(order)}
						deleteOrder={() => {
							setProceedAction(() => () => deleteOrder(order));
							setDiscardOrderConfirmOpen(true);
						}}
						goToEditOrderPage={() => goToEditOrderPage(order)}
						goToOrderReportPage={() => goToOrderReportPage(order)}
					/>
				);
		  })
		: [];

	return <div className="view-order-grid-table">{sampleCells}</div>;
}
